import { lazy } from "react"

type ComponentImportFn = () => Promise<{ default: React.ComponentType<any> }>

const RETRY_COUNT = 2
const RETRY_DELAY_MS = 1000

export function isChunkLoadError(error: Error): boolean {
  return (
    error.name === "ChunkLoadError" ||
    error.message.includes("Loading chunk") ||
    error.message.includes("Failed to fetch dynamically imported module") ||
    error.message.includes("Importing a module script failed")
  )
}

export function lazyRetry(importFn: ComponentImportFn) {
  return lazy(async () => {
    for (let attempt = 0; attempt <= RETRY_COUNT; attempt++) {
      try {
        return await importFn()
      } catch (error) {
        const isLast = attempt === RETRY_COUNT
        const isChunk = error instanceof Error && isChunkLoadError(error)

        if (!isChunk || isLast) {
          throw error
        }

        await new Promise((r) => setTimeout(r, RETRY_DELAY_MS))
      }
    }
    throw new Error("lazyRetry: unreachable")
  })
}
